import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class OrganizationsService {
  static async getAll() {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/organizations`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
